import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import length from '@turf/length';

import { RoutingInformation } from './RoutingInformation';
import { LengthBadgeFeature } from '../components/Badge/LengthBadge';
import { AccBadge } from '../components/Badge/AccBadge';

export const PedestrianVisual = ({
  actualFeature, 
  nextFeature, 
  typeAcc
}) => {
  const styles = {
    container: {
      display: 'flex',
      width: '100%'
    },
    chipContainer: {
      display: 'flex', 
      width: '100%', 
      
    }
  };

  const renderIcon = (actual, next) => {
    if (next) {
      if (next.properties.m === 'transit') {
        return actual.properties.type;
      } else {
        return next.properties.type;
      }
    }
  };

  return (
    <Stack sx={styles.container} spacing={2}>
      <RoutingInformation 
        ta={actualFeature.properties.ta}
        name={actualFeature.properties.name}
        type={renderIcon(actualFeature, nextFeature)} 
        instruction={actualFeature.properties.voice_post}
        obstacles={actualFeature.properties.has_obstacles}
        nextInstruction={nextFeature && nextFeature.properties.voice_pre}
      />
      {length(actualFeature) > 0 && (
        <Box sx={{display: 'flex', width: '100%'}}>
          <Stack sx={styles.chipContainer} direction='row' spacing={1.5}>
            <Box sx={{display: 'flex'}}>
              <AccBadge acc={actualFeature.properties.acc} typeAcc={typeAcc} />
            </Box>
            <Box sx={{display: 'flex'}}>
              <LengthBadgeFeature feature={actualFeature}/>
            </Box> 
          </Stack>
        </Box>
      )}
    </Stack>
  );
};